import { CommonFetchPost, CommonExportGet, CommonFetchPostLong } from './request'
import API from './api'

/**
 * 平台账号登录
 * @param  data
 * @returns
 */
export const LoginByEmail = async (data: any) => {
  return await CommonFetchPost(API.loginByEmail, data)
}
/**
 * 平台账号登录
 * @param  data
 * @returns
 */
export const LoginByAccount = async (data: any) => {
  return await CommonFetchPost(API.loginByAccount, data)
}
/**
 * 平台账号退出登录
 * @param  data
 * @returns
 */
export const LoginOut = async () => {
  return await CommonFetchPost(API.loginOut, {})
}

/**
 * 修改密码（平台登录账号）
 * @param  data
 * @returns
 */
export const UpdatePlatformAccountPassword = async (data: any) => {
  return await CommonFetchPost(API.updatePlatformAccountPassword, data)
}

/**
 * 查询平台账号列表
 * @param  data
 * @returns
 */
export const QueryPlatformAccountList = async (data: any) => {
  return await CommonFetchPost(API.queryPlatformAccountList, data)
}
/**
 * 创建平台登录账号
 * @param  data
 * @returns
 */
export const CreatePlatformAccount = async (data: any) => {
  return await CommonFetchPost(API.createPlatformAccount, data)
}
/**
 * 重置密码（平台端）
 * @param  data
 * @returns
 */
export const ResetPasswordsForPlatformAccount = async (data: any) => {
  return await CommonFetchPost(API.resetPasswordsForPlatformAccount, data)
}
/**
 * 重置密码（平台端）
 * @param  data
 * @returns
 */
export const GetCurrentPlatform = async () => {
  return await CommonFetchPost(API.getCurrentPlatform, {})
}
/**
 * 重置密码（平台端）
 * @param  data
 * @returns
 */
export const UpdatePlatformAccount = async (data: any) => {
  return await CommonFetchPost(API.updatePlatformAccount, data)
}

/**
 * 查询渠道列表
 * @param  data
 * @returns
 */
export const QueryUserChannelList = async (data: any) => {
  return await CommonFetchPost(API.queryUserChannelList, data)
}
/**
 * 创建渠道
 * @param  data
 * @returns
 */
export const CreateUserChannel = async (data: any) => {
  return await CommonFetchPost(API.createUserChannel, data)
}
/**
 * 修改渠道
 * @param  data
 * @returns
 */
export const UpdateUserChannel = async (data: any) => {
  return await CommonFetchPost(API.updateUserChannel, data)
}
/**
 * 删除渠道
 * @param  data
 * @returns
 */
export const DeleteUserChannel = async (data: any) => {
  return await CommonFetchPost(API.deleteUserChannel, data)
}

/**
 * 文件上传
 * @param  data
 * @returns
 */
export const FileUpload = async (data: any) => {
  return await CommonFetchPost(API.fileUpload, data)
}

/**
 * 查询户主信息
 * @param  data
 * @returns
 */
export const QueryHouseList = async (data: any) => {
  return await CommonFetchPost(API.queryHouseList, data)
}

/**
 * 通过编号查询房子信息
 * @param  data
 * @returns
 */
export const QueryHouseByCode = async (data: any) => {
  return await CommonFetchPost(API.queryHouseByCode, data)
}

/**
 * 创建房子
 * @param  data
 * @returns
 */
export const CreateHouseInfo = async (data: any) => {
  return await CommonFetchPost(API.createHouseInfo, data)
}

/**
 * 更新房子
 * @param  data
 * @returns
 */
export const UpdateHouseInfo = async (data: any) => {
  return await CommonFetchPost(API.updateHouseInfo, data)
}

/**
 * 批量创建房子信息（配合导入房子信息接口使用）
 * @param  data
 * @returns
 */
export const BarchCreateHouseInfo = async (data: any) => {
  return await CommonFetchPost(API.barchCreateHouseInfo, data)
}

/**
 * 查询用户信息列表
 * @param  data
 * @returns
 */
export const QueryUserList = async (data: any) => {
  return await CommonFetchPost(API.queryUserList, data)
}
/**
 * 平台PV流水导出
 * @param  data
 * @returns
 */
export const ExportUserList = async (data: any, fileName= "平台PV流水.xlsx") => {
  return await CommonExportGet(API.exportUserList, data,fileName)
}
/**
 * 查询店铺用户信息列表
 * @param  data
 * @returns
 */
export const QueryShopUserList = async (data: any) => {
  return await CommonFetchPost(API.queryShopUserList, data)
}
/**
 * 查询用户信息
 * @param  data
 * @returns
 */
export const QueryUserById = async (data: any) => {
  return await CommonFetchPost(API.queryUserById, data)
}
/**
 * 更新用户信息（角色）
 * @param  data
 * @returns
 */
export const UpdateInfo = async (data: any) => {
  return await CommonFetchPost(API.updateInfo, data)
}

/**
 * 查询商品信息列表
 * @param  data
 * @returns
 */
export const QueryGoodsList = async (data: any) => {
  return await CommonFetchPost(API.queryGoodsList, data)
}
/**
 * 查询商品数量统计
 * @param  data
 * @returns
 */
export const QueryGoodsCounts = async (data: any) => {
  return await CommonFetchPost(API.queryGoodsCounts, data)
}
/**
 * 商品导出
 * @param  data
 * @returns
 */
export const ExportGoods = async (data: any, fileName= "default.xlsx") => {
  return await CommonExportGet(API.exportGoods, data,fileName)
}

/**
 * 通过Codee查询
 * @param  data
 * @returns
 */
export const QueryGoodsByCodee = async (data: any) => {
  return await CommonFetchPost(API.queryGoodsByCodee, data)
}

/**
 * 创建商品
 * @param  data
 * @returns
 */
export const CareateGoods = async (data: any) => {
  return await CommonFetchPost(API.careateGoods, data)
}

/**
 * 修改商品
 * @param  data
 * @returns
 */
export const UpdateGoods = async (data: any) => {
  return await CommonFetchPost(API.updateGoods, data)
}

/**
 * 删除商品
 * @param  data
 * @returns
 */
export const DeleteGoods = async (data: any) => {
  return await CommonFetchPost(API.deleteGoods, data)
}

/**
 * 商品上架/下架
 * @param  data
 * @returns
 */
export const UpdateGoodsStatus = async (data: any) => {
  return await CommonFetchPost(API.updateGoodsStatus, data)
}


/**
 * 商品免单/免单2
 * @param  data
 * @returns
 */
export const UpdateGoodsMian = async (data: any) => {
  return await CommonFetchPost(API.updateGoodsMian, data)
}

/**
 * 商品上架/下架
 * @param  data
 * @returns
 */
export const BatchUpdateGoodsStatus = async (data: any) => {
  return await CommonFetchPost(API.batchUpdateGoodsStatus, data)
}

/**
 * 商品批量删除
 * @param  data
 * @returns
 */
export const BatchDeleteGoods = async (data: any) => {
  return await CommonFetchPost(API.batchDeleteGoods, data)
}
/**
 * 商品审核通过
 * @param  data
 * @returns
 */
export const GoodsAuditPass = async (data: any) => {
  return await CommonFetchPost(API.goodsAuditPass, data)
}
/**
 * 商品审核驳回
 * @param  data
 * @returns
 */
export const GoodsAuditReject = async (data: any) => {
  return await CommonFetchPost(API.goodsAuditReject, data)
}
/**
 * 批量移除首页商品
 * @param  data
 * @returns
 */
export const BatchRemoveIndexGoods = async (data: any) => {
  return await CommonFetchPost(API.batchRemoveIndexGoods, data)
}
/**
 * 批量添加首页商品
 * @param  data
 * @returns
 */
export const BatchAddIndexGoods = async (data: any) => {
  return await CommonFetchPost(API.batchAddIndexGoods, data)
}
/**
 * 批量移除支付立减商品
 * @param  data
 * @returns
 */
export const BatchRemovePaymentDiscountGoods = async (data: any) => {
  return await CommonFetchPost(API.batchRemovePaymentDiscountGoods, data)
}
/**
 * 批量添加支付立减商品
 * @param  data
 * @returns
 */
export const BatchAddPaymentDiscountGoods = async (data: any) => {
  return await CommonFetchPost(API.batchAddPaymentDiscountGoods, data)
}

// 一县一特
export const QueryCityGoodsList = async (data: any) => {
  return await CommonFetchPost(API.queryCityGoodsList, data)
}
export const QueryEachCityGoodsCount = async (data: any) => {
  return await CommonFetchPost(API.queryEachCityGoodsCount, data)
}
export const BatchAddCityGoods = async (data: any) => {
  return await CommonFetchPost(API.batchAddCityGoods, data)
}
export const BatchDeleteCityGoods = async (data: any) => {
  return await CommonFetchPost(API.batchDeleteCityGoods, data)
}

// 一县一特-分类
export const QueryCityClassifyTree = async (data: any) => {
  return await CommonFetchPost(API.queryCityClassifyTree, data)
}
export const QueryCityClassifyList = async (data: any) => {
  return await CommonFetchPost(API.queryCityClassifyList, data)
}
export const AddCityClassify = async (data: any) => {
  return await CommonFetchPost(API.addCityClassify, data)
}
export const UpdateCityClassify = async (data: any) => {
  return await CommonFetchPost(API.updateCityClassify, data)
}
export const DeleteCityClassify = async (data: any) => {
  return await CommonFetchPost(API.deleteCityClassify, data)
}

/**
 * 查询活动列表
 * @param  data
 * @returns
 */
export const QueryActivityList = async (data: any) => {
  return await CommonFetchPost(API.queryActivityList, data)
}

/**
 * 创建活动
 * @param  data
 * @returns
 */
export const CreateActivity = async (data: any) => {
  return await CommonFetchPost(API.createActivity, data)
}

/**
 * 修改活动
 * @param  data
 * @returns
 */
export const UpdateActivity = async (data: any) => {
  return await CommonFetchPost(API.updateActivity, data)
}

/**
 * 删除活动
 * @param  data
 * @returns
 */
export const DeleteActivity = async (data: any) => {
  return await CommonFetchPost(API.deleteActivity, data)
}

/**
 * 查询活动商品列表
 * @param  data
 * @returns
 */
export const QueryActivityGoodsList = async (data: any) => {
  return await CommonFetchPost(API.queryActivityGoodsList, data)
}
/**
 * 查询活动商品列表
 * @param  data
 * @returns
 */
export const QueryActivityGoodsAllList = async (data: any) => {
  return await CommonFetchPost(API.queryActivityGoodsAllList, data)
}

/**
 * 添加活动商品
 * @param  data
 * @returns
 */
export const AddActivityGoods = async (data: any) => {
  return await CommonFetchPost(API.addActivityGoods, data)
}

/**
 * 批量添加活动商品
 * @param  data
 * @returns
 */
export const BatchAddActivityGoods = async (data: any) => {
  return await CommonFetchPost(API.batchAddActivityGoods, data)
}

/**
 * 删除活动商品
 * @param  data
 * @returns
 */
export const UpdateActivityGoods = async (data: any) => {
  return await CommonFetchPost(API.updateActivityGoods, data)
}

/**
 * 删除活动商品
 * @param  data
 * @returns
 */
export const DeleteActivityGoods = async (data: any) => {
  return await CommonFetchPost(API.deleteActivityGoods, data)
}
/**
 * 批量删除活动商品
 * @param  data
 * @returns
 */
export const BatchDeleteActivityGoods = async (data: any) => {
  return await CommonFetchPost(API.batchDeleteActivityGoods, data)
}

/**
 * 查询分类树
 * @param  data
 * @returns
 */
export const QueryClassifyTree = async (data: any) => {
  return await CommonFetchPost(API.queryClassifyTree, data)
}

/**
 * 创建分类
 * @param  data
 * @returns
 */
export const CreateClassify = async (data: any) => {
  return await CommonFetchPost(API.createClassify, data)
}

/**
 * 更新分类
 * @param  data
 * @returns
 */
export const UpdateClassify = async (data: any) => {
  return await CommonFetchPost(API.updateClassify, data)
}

/**
 * 删除分类
 * @param  data
 * @returns
 */
export const DeleteClassify = async (data: any) => {
  return await CommonFetchPost(API.deleteClassify, data)
}

/**
 * 保存分类排序
 * @param  data
 * @returns
 */
export const SaveClassifySort = async (data: any) => {
  return await CommonFetchPost(API.saveClassifySort, data)
}

/**
 * 查询订单列表
 * @param  data
 * @returns
 */
export const QueryOrderInfoList = async (data: any) => {
  return await CommonFetchPost(API.queryOrderInfoList, data)
}

/** 售后/退款 Tab：直接查 zy_order_refund */
export const QueryAfterSaleRefundList = async (data: any) => {
  return await CommonFetchPost(API.queryAfterSaleRefundList, data)
}
/**
 * 查询各订单分类数量
 * @param  data
 * @returns
 */
export const QueryOrderInfoCounts = async (data: any) => {
  return await CommonFetchPost(API.queryOrderInfoCounts, data)
}
/**
 * 查询各结算订单分类数量
 * @param  data
 * @returns
 */
export const QuerySettlementOrderCounts = async (data: any) => {
  return await CommonFetchPost(API.querySettlementOrderCounts, data)
}
/**
 * 通过订单编号，获取订单信息
 * @param  data
 * @returns
 */
export const QueryOrderInfoByCode = async (data: any) => {
  return await CommonFetchPost(API.queryOrderInfoByCode, data)
}
/**
 * 查询订单商品明细列表
 * @param  data
 * @returns
 */
export const QueryOrderGoodsDescList = async (data: any) => {
  return await CommonFetchPost(API.queryOrderGoodsDescList, data)
}

/** 订单吉客云同步/回调日志 */
export const ListJkySyncLogByOrderCode = async (data: { orderCode: string }) => {
  return await CommonFetchPost(API.listJkySyncLogByOrderCode, data)
}

/** 订单财富明细（用户贡献值/绿豆/能量值、店铺结算、平台PV） */
export const QueryOrderWealthDetail = async (data: { orderCode: string }) => {
  return await CommonFetchPost(API.queryOrderWealthDetail, data)
}

/**
 * 确认订单
 * @param  data
 * @returns
 */
export const ConfirmOrder = async (data: any) => {
  return await CommonFetchPost(API.confirmOrder, data)
}
/**
 * 订单发货
 * @param  data
 * @returns
 */
export const DeliveryOrder = async (data: any) => {
  return await CommonFetchPost(API.deliveryOrder, data)
}
/**
 * 订单发货
 * @param  data
 * @returns
 */
export const UpdateExpressOrder = async (data: any) => {
  return await CommonFetchPost(API.updateExpressOrder, data)
}
/**
 * 拒绝订单
 * @param  data
 * @returns
 */
export const RefusedOrder = async (data: any) => {
  return await CommonFetchPost(API.refusedOrder, data)
}
/**
 * 批量确认订单
 * @param  data
 * @returns
 */
export const BatchConfirmOrder = async (data: any) => {
  return await CommonFetchPost(API.batchConfirmOrder, data)
}
/**
 * 批量订单发货
 * @param  data
 * @returns
 */
export const BatchDeliveryOrder = async (data: any) => {
  return await CommonFetchPost(API.batchDeliveryOrder, data)
}
/**
 * 确认退款
 * @param  data
 * @returns
 */
export const ConfirmRefund = async (data: any) => {
  return await CommonFetchPost(API.confirmRefund, data)
}
/** 退款后置状态补正预览（管理员） */
export const PreviewRefundPostProcessCorrection = async (data: any) => {
  return await CommonFetchPost(API.previewRefundPostProcessCorrection, data)
}
/** 退款后置状态补正执行（管理员） */
export const ApplyRefundPostProcessCorrection = async (data: any) => {
  return await CommonFetchPost(API.applyRefundPostProcessCorrection, data)
}
/** 批量退款后置状态补正预览（管理员） */
export const BatchPreviewRefundPostProcessCorrection = async (data: any) => {
  return await CommonFetchPost(API.batchPreviewRefundPostProcessCorrection, data)
}
/** 批量退款后置状态补正执行（管理员） */
export const BatchApplyRefundPostProcessCorrection = async (data: any) => {
  return await CommonFetchPost(API.batchApplyRefundPostProcessCorrection, data)
}
/**
 * 退货退款：买家已寄回（物流进行中/已签收）后，商家确认并发起原路退款
 */
export const ConfirmReturnRefundAfterLogistics = async (data: any) => {
  return await CommonFetchPost(API.confirmReturnRefundAfterLogistics, data)
}
/**
 * 取消退款
 * @param  data
 * @returns
 */
export const CancelRefund = async (data: any) => {
  return await CommonFetchPost(API.cancelRefund, data)
}
/**
 * 订单导出
 * @param  data
 * @returns
 */
export const ExportOrder = async (data: any, fileName= "default.xlsx") => {
  return await CommonExportGet(API.exportOrder, data,fileName)
}
/**
 * 订单导出
 * @param  data
 * @returns
 */
export const ExportSettlementOrder = async (data: any, fileName= "default.xlsx") => {
  return await CommonExportGet(API.exportSettlementOrder, data,fileName)
}
/**
 * 修改配送方式
 * @param  data
 * @returns
 */
export const UpdateDeliveryType = async (data: any) => {
  return await CommonFetchPost(API.updateDeliveryType, data)
}
/**
 * 修改收货地址
 * @param  data
 * @returns
 */
export const UpdateDeliveryAddress = async (data: any) => {
  return await CommonFetchPost(API.updateDeliveryAddress, data)
}
/**
 * 订单分佣异常补偿记录列表
 * @param  data
 * @returns
 */
export const QueryOrderAllocateErrorRecordList = async (data: any) => {
  return await CommonFetchPost(API.queryOrderAllocateErrorRecordList, data)
}
/**
 * 订单分佣异常补偿记录 数量
 * @param  data
 * @returns
 */
export const QueryOrderAllocateErrorRecordCount = async (data: any) => {
  return await CommonFetchPost(API.queryOrderAllocateErrorRecordCount, data)
}

/**
 * 账单列表
 * @param  data
 * @returns
 */
export const QueryBillInfoList = async (data: any) => {
  return await CommonFetchPost(API.queryBillInfoList, data)
}

/**
 * 通过编号查询支付订单
 * @param  data
 * @returns
 */
export const QueryPayOrderByNo = async (data: any) => {
  return await CommonFetchPost(API.queryPayOrderByNo, data)
}

/**
 * 查询宣传页列表
 * @param  data
 * @returns
 */
export const QueryBrochureList = async (data: any) => {
  return await CommonFetchPost(API.queryBrochureList, data)
}
/**
 * 通过id查询宣传页
 * @param  data
 * @returns
 */
export const QueryBrochureById = async (data: any) => {
  return await CommonFetchPost(API.queryBrochureById, data)
}
/**
 * 创建宣传页
 * @param  data
 * @returns
 */
export const CreateBrochure = async (data: any) => {
  return await CommonFetchPost(API.createBrochure, data)
}
/**
 * 修改宣传页
 * @param  data
 * @returns
 */
export const UpdateBrochure = async (data: any) => {
  return await CommonFetchPost(API.updateBrochure, data)
}
/**
 * 删除宣传页
 * @param  data
 * @returns
 */
export const DeleteBrochure = async (data: any) => {
  return await CommonFetchPost(API.deleteBrochure, data)
}

/**
 * 查询资讯列表
 * @param  data
 * @returns
 */
export const QueryInformationList = async (data: any) => {
  return await CommonFetchPost(API.queryInformationList, data)
}
/**
 * 通过id查询资讯
 * @param  data
 * @returns
 */
export const QueryInformationById = async (data: any) => {
  return await CommonFetchPost(API.queryInformationById, data)
}
/**
 * 创建资讯
 * @param  data
 * @returns
 */
export const CreateInformation = async (data: any) => {
  return await CommonFetchPost(API.createInformation, data)
}
/**
 * 更新资讯
 * @param  data
 * @returns
 */
export const UpdateInformation = async (data: any) => {
  return await CommonFetchPost(API.updateInformation, data)
}
/**
 * 删除资讯
 * @param  data
 * @returns
 */
export const DeleteInformation = async (data: any) => {
  return await CommonFetchPost(API.deleteInformation, data)
}

/**
 * 查询社区活动列表
 * @param  data
 * @returns
 */
export const QueryActivityInfoList = async (data: any) => {
  return await CommonFetchPost(API.queryActivityInfoList, data)
}
/**
 * 通过code查询社区活动
 * @param  data
 * @returns
 */
export const QueryActivityInfoByCode = async (data: any) => {
  return await CommonFetchPost(API.queryActivityInfoByCode, data)
}
/**
 * 创建社区活动
 * @param  data
 * @returns
 */
export const CreateActivityInfo = async (data: any) => {
  return await CommonFetchPost(API.createActivityInfo, data)
}
/**
 * 更新社区活动
 * @param  data
 * @returns
 */
export const UpdateActivityInfo = async (data: any) => {
  return await CommonFetchPost(API.updateActivityInfo, data)
}
/**
 * 删除社区活动
 * @param  data
 * @returns
 */
export const DeleteActivityInfo = async (data: any) => {
  return await CommonFetchPost(API.deleteActivityInfo, data)
}
/**
 * 查询社区活动报名表
 * @param  data
 * @returns
 */
export const QueryActivityApplyList = async (data: any) => {
  return await CommonFetchPost(API.queryActivityApplyList, data)
}

/**
 * 查询供应商列表
 * @param  data
 * @returns
 */
export const QuerySupplierList = async (data: any) => {
  return await CommonFetchPost(API.querySupplierList, data)
}
/**
 * 通过code获取供应商
 * @param  data
 * @returns
 */
export const QuerySupplierInfoByCode = async (data: any) => {
  return await CommonFetchPost(API.querySupplierInfoByCode, data)
}
/**
 * 添加供应商
 * @param  data
 * @returns
 */
export const AddSupplierInfo = async (data: any) => {
  return await CommonFetchPost(API.addSupplierInfo, data)
}
/**
 * 修改供应商
 * @param  data
 * @returns
 */
export const UpdateSupplierInfo = async (data: any) => {
  return await CommonFetchPost(API.updateSupplierInfo, data)
}
/**
 * 删除供应商
 * @param  data
 * @returns
 */
export const DeleteSupplierInfo = async (data: any) => {
  return await CommonFetchPost(API.deleteSupplierInfo, data)
}

/**
 * 查询banner
 * @param  data
 * @returns
 */
export const QueryBannerList = async (data: any) => {
  return await CommonFetchPost(API.queryBannerList, data)
}
/**
 * 添加banner
 * @param  data
 * @returns
 */
export const AddBanner = async (data: any) => {
  return await CommonFetchPost(API.addBanner, data)
}
/**
 * 修改banner顺序
 * @param  data
 * @returns
 */
export const ChangeBannersStatus = async (data: any) => {
  return await CommonFetchPost(API.changeBannersStatus, data)
}
/**
 * 删除banner
 * @param  data
 * @returns
 */
export const DeleteBanner = async (data: any) => {
  return await CommonFetchPost(API.deleteBanner, data)
}
/**
 * 修改banner
 * @param  data
 * @returns
 */
export const UpdateBanner = async (data: any) => {
  return await CommonFetchPost(API.updateBanner, data)
}


/**
 * 查询导航栏列表
 * @param  data
 * @returns
 */
export const QueryNavigationList = async (data: any) => {
  return await CommonFetchPost(API.queryNavigationList, data)
}
/**
 * 查询导航栏列表
 * @param  data
 * @returns
 */
export const CreateNavigation = async (data: any) => {
  return await CommonFetchPost(API.createNavigation, data)
}
/**
 * 查询导航栏列表
 * @param  data
 * @returns
 */
export const UpdateNavigation = async (data: any) => {
  return await CommonFetchPost(API.updateNavigation, data)
}
/**
 * 查询导航栏列表
 * @param  data
 * @returns
 */
export const DeleteNavigation = async (data: any) => {
  return await CommonFetchPost(API.deleteNavigation, data)
}


/** 提货卷 */
export const QueryVoucherModelList = async (data: any) => {
  return await CommonFetchPost(API.queryVoucherModelList, data)
}
export const QueryVoucherModelById = async (data: any) => {
  return await CommonFetchPost(API.queryVoucherModelById, data)
}
export const AddVoucherModel = async (data: any) => {
  return await CommonFetchPost(API.addVoucherModel, data)
}
export const UpdateVoucherModel = async (data: any) => {
  return await CommonFetchPost(API.updateVoucherModel, data)
}
export const DeleteVoucherModel = async (data: any) => {
  return await CommonFetchPost(API.deleteVoucherModel, data)
}
export const UpdateVoucherModelStatus = async (data: any) => {
  return await CommonFetchPost(API.updateVoucherModelStatus, data)
}

export const QueryUserVoucherList = async (data: any) => {
  return await CommonFetchPost(API.queryUserVoucherList, data)
}
export const QueryUserVoucherById = async (data: any) => {
  return await CommonFetchPost(API.queryUserVoucherById, data)
}



export const VideoQueryList = async (data: any) => {
  return await CommonFetchPost(API.videoQueryList, data)
}
export const VideoCreate = async (data: any) => {
  return await CommonFetchPost(API.videoCreate, data)
}
export const VideoEdit = async (data: any) => {
  return await CommonFetchPost(API.videoEdit, data)
}
export const VideoDelte = async (data: any) => {
  return await CommonFetchPost(API.videoDelete, data)
}
export const VideoQueryGoodsList = async (data: any) => {
  return await CommonFetchPost(API.videoQueryGoodsList, data)
}
export const DeleteBindGoodds = async (data: any) => {
  return await CommonFetchPost(API.deleteBindGoodds, data)
}
export const AddBindGoodds = async (data: any) => {
  return await CommonFetchPost(API.addBindGoodds, data)
}

export const QueryShopList = async (data: any) => {
  return await CommonFetchPost(API.queryShopList, data)
}
export const QueryShopSpecialRefundEstimateSummary = async (data: any) => {
  return await CommonFetchPost(API.queryShopSpecialRefundEstimateSummary, data)
}
export const QueryAllShopNameList = async (data: any) => {
  return await CommonFetchPost(API.queryAllShopNameList, data)
}
export const QueryShopById = async (data: any) => {
  return await CommonFetchPost(API.queryShopById, data)
}
export const QueryShopWealthDetail = async (data: any) => {
  return await CommonFetchPost(API.queryShopWealthDetail, data)
}
export const CreateShop = async (data: any) => {
  return await CommonFetchPost(API.createShop, data)
}
export const UpdateShop = async (data: any) => {
  return await CommonFetchPost(API.updateShop, data)
}
export const UpdateBaseShop = async (data: any) => {
  return await CommonFetchPost(API.updateBaseShop, data)
}
export const DeleteShop = async (data: any) => {
  return await CommonFetchPost(API.deleteShop, data)
}
export const UpdateShopStatus = async (data: any) => {
  return await CommonFetchPost(API.updateShopStatus, data)
}
export const UpdateShopPlatformClose = async (data: any) => {
  return await CommonFetchPost(API.updateShopPlatformClose, data)
}
export const UpdateShopAuditStatus = async (data: any) => {
  return await CommonFetchPost(API.updateShopAuditStatus, data)
}
export const ShopAuditPass = async (data: any) => {
  return await CommonFetchPost(API.shopAuditPass, data)
}
export const ShopAuditRefuse = async (data: any) => {
  return await CommonFetchPost(API.shopAuditRefuse, data)
}
export const RegistSucccess = async (data: any) => {
  return await CommonFetchPost(API.registSucccess, data)
}
export const QueryCurrentShop = async () => {
  return await CommonFetchPost(API.queryCurrentShop, {})
}
export const SubmitShopAuditStatus = async (data: any) => {
  return await CommonFetchPost(API.submitShopAuditStatus, data)
}
export const QueryCurrentShopRegistMerchant = async (data: any) => {
  return await CommonFetchPost(API.queryCurrentShopRegistMerchant, data)
}


export const MCQueryList = async (data: any) => {
  return await CommonFetchPost(API.MCQueryList, data)
}
export const MCCreate = async (data: any) => {
  return await CommonFetchPost(API.MCCreate, data)
}
export const MCUpdate = async (data: any) => {
  return await CommonFetchPost(API.MCUpdate, data)
}
export const MCUpdateStatus = async (data: any) => {
  return await CommonFetchPost(API.MCUpdateStatus, data)
}
export const MCQueryStatusList = async (data: any) => {
  return await CommonFetchPost(API.MCQueryStatusList, data)
}
export const MCQueryInvestorList = async (data: any) => {
  return await CommonFetchPost(API.MCQueryInvestorList, data)
}

export const BindMedicineCabinet = async (data: any) => {
  return await CommonFetchPost(API.bindMedicineCabinet, data)
}
export const UnbindMedicineCabinet = async (data: any) => {
  return await CommonFetchPost(API.unbindMedicineCabinet, data)
}
export const QueryMedicineCabinetList = async (data: any) => {
  return await CommonFetchPost(API.queryMedicineCabinetList, data)
}
export const UploadIncomeFile = async (data: any) => {
  return await CommonFetchPost(API.uploadIncomeFile, data)
}
export const QueryIncomeFileList = async (data: any) => {
  return await CommonFetchPost(API.queryIncomeFileList, data)
}
export const QueryIncome = async (data: any) => {
  return await CommonFetchPost(API.queryIncome, data)
}
export const QueryIncomeDetail = async (data: any) => {
  return await CommonFetchPost(API.queryIncomeDetail, data)
}
export const QueryPlatformOperatingIncome = async (data: any) => {
  return await CommonFetchPost(API.queryPlatformOperatingIncome, data)
}


// 银行列表
export const QueryBankCodeList = async (data: any) => {
  return await CommonFetchPost(API.queryBankCodeList, data)
}
export const QueryBankCodeById = async (data: any) => {
  return await CommonFetchPost(API.queryBankCodeById, data)
}
export const CreateBankCode = async (data: any) => {
  return await CommonFetchPost(API.createBankCode, data)
}
export const UpdateBankCode = async (data: any) => {
  return await CommonFetchPost(API.updateBankCode, data)
}
export const DeleteBankCode = async (data: any) => {
  return await CommonFetchPost(API.deleteBankCode, data)
}
export const QueryBankBranchList = async (data: any) => {
  return await CommonFetchPost(API.queryBankBranchList, data)
}

// 变更银行卡相关接口
export const QueryBankCardByShopId = async (data: any) => {
  return await CommonFetchPost(API.queryBankCardByShopId, data)
}
export const ChangeBankCardApply = async (data: any) => {
  return await CommonFetchPost(API.changeBankCardApply, data)
}
export const ChangeBankCardVerify = async (data: any) => {
  return await CommonFetchPost(API.changeBankCardVerify, data)
}

// 银行卡
// 查询店铺银行卡列表
export const QueryShopBankCardList = async (data: any) => {
  return await CommonFetchPost(API.queryShopBankCardList, data)
}
export const CreateShopBankCard = async (data: any) => {
  return await CommonFetchPost(API.createShopBankCard, data)
}
export const DeleteBankCard = async (data: any) => {
  return await CommonFetchPost(API.deleteBankCard, data)
}


// 配置
export const QueryConfigLIst = async (data: any) => {
  return await CommonFetchPost(API.queryConfigLIst, data)
}
export const QueryConfigById = async (data: any) => {
  return await CommonFetchPost(API.queryConfigById, data)
}
export const AddSysConfig = async (data: any) => {
  return await CommonFetchPost(API.addSysConfig, data)
}
export const UpdateSysConfig = async (data: any) => {
  return await CommonFetchPost(API.updateSysConfig, data)
}
export const RemoveSysConfig = async (data: any) => {
  return await CommonFetchPost(API.removeSysConfig, data)
}
export const UpdateOrSaveSysConfigByParam = async (data: any) => {
  return await CommonFetchPost(API.updateOrSaveSysConfigByParam, data)
}

// 微信广告奖励配置
export const SyncWechatAdUnitList = async () => {
  return await CommonFetchPost(API.syncWechatAdUnitList, {})
}
export const QueryWechatAdUnitList = async () => {
  return await CommonFetchPost(API.queryWechatAdUnitList, {})
}
export const QueryWechatAdRewardConfig = async (data: { adUnitId: string }) => {
  return await CommonFetchPost(API.queryWechatAdRewardConfig, data)
}
export const SaveWechatAdRewardConfig = async (data: any) => {
  return await CommonFetchPost(API.saveWechatAdRewardConfig, data)
}

export const QueryCouponTemplateList = async (data: any = {}) => {
  return await CommonFetchPost(API.couponTemplateList, data)
}
export const SaveCouponTemplate = async (data: any) => {
  return await CommonFetchPost(API.couponTemplateSave, data)
}
export const GrantUserCoupon = async (data: any) => {
  return await CommonFetchPost(API.couponGrant, data)
}
export const VoidUserCoupon = async (data: any) => {
  return await CommonFetchPost(API.couponVoidUserCoupon, data)
}
export const QueryCouponGrantLogList = async (data: any) => {
  return await CommonFetchPost(API.couponGrantLogList, data)
}
export const QueryCouponUserCouponList = async (data: any) => {
  return await CommonFetchPost(API.couponUserCouponList, data)
}
export const QueryCouponOpsOverview = async (data: any = {}) => {
  return await CommonFetchPost(API.couponOpsOverview, data)
}
export const ExportCouponGrantLogList = async (data: any, fileName = '优惠券发放记录.xlsx') => {
  return await CommonExportGet(API.exportCouponGrantLogList, data, fileName)
}
export const ExportCouponUserCouponList = async (data: any, fileName = '用户优惠券.xlsx') => {
  return await CommonExportGet(API.exportCouponUserCouponList, data, fileName)
}
export const ExportUserPointsRecordList = async (data: any, fileName = '积分明细.xlsx') => {
  return await CommonExportGet(API.exportUserPointsRecordList, data, fileName)
}

// 签到/活跃度配置
export const GetUserCheckinConfig = async () => {
  return await CommonFetchPost(API.getUserCheckinConfig, {})
}
export const SaveUserCheckinConfig = async (data: any) => {
  return await CommonFetchPost(API.saveUserCheckinConfig, data)
}
export const ListUserCheckinSpecialReward = async (data: any) => {
  return await CommonFetchPost(API.listUserCheckinSpecialReward, data)
}
export const SaveUserCheckinSpecialReward = async (data: any) => {
  return await CommonFetchPost(API.saveUserCheckinSpecialReward, data)
}
export const DeleteUserCheckinSpecialReward = async (data: { rewardDate: string }) => {
  return await CommonFetchPost(API.deleteUserCheckinSpecialReward, data)
}
export const GetActivityDailyRankRewardConfig = async () => {
  return await CommonFetchPost(API.getActivityDailyRankRewardConfig, {})
}
export const SaveActivityDailyRankRewardConfig = async (data: any) => {
  return await CommonFetchPost(API.saveActivityDailyRankRewardConfig, data)
}
export const SettleActivityDailyRankReward = async (data: { rewardDate?: string }) => {
  return await CommonFetchPost(API.settleActivityDailyRankReward, data || {})
}

export const QueryUserCheckinRecordList = async (data: any) => {
  return await CommonFetchPost(API.queryUserCheckinRecordList, data)
}
export const QueryUserActivityRecordList = async (data: any) => {
  return await CommonFetchPost(API.queryUserActivityRecordList, data)
}

export const QueryDayActivityLeaderboard = async (data: any) => {
  return await CommonFetchPost(API.queryDayActivityLeaderboard, data)
}

/**
 * 快递公司查询
 * @param  data
 * @returns
 */
export const QueryExpressCompanyList = async () => {
  return await CommonFetchPost(API.queryExpressCompanyList)
}

/**
 * 物流订单列表查询
 * @param  data
 * @returns
 */
export const QueryExpressOrderList = async (data: any) => {
  return await CommonFetchPost(API.queryExpressOrderList, data)
}

/** 快递100订阅失败分页列表 */
export const QueryKuaidi100SubscribePendingList = async (data: any) => {
  return await CommonFetchPost(API.kuaidi100SubscribePendingList, data)
}

/** 后台重试快递100订阅 */
export const RetryKuaidi100Subscribe = async (data: { id: number }) => {
  return await CommonFetchPost(API.kuaidi100RetrySubscribe, data)
}

/**
 * 会员列表查询
 * @param  data
 * @returns
 */
export const QueryMemberList = async (data: any) => {
  return await CommonFetchPost(API.queryMemberList, data)
}

/**
 * 活动列表查询
 * @param  data
 * @returns
 */
export const QueryActivityAllList = async () => {
  return await CommonFetchPost(API.queryActivityAllList)
}

/**
 * 创建会员
 * @param  data
 * @returns
 */
export const CreteMember = async (data: any) => {
  return await CommonFetchPost(API.creteMember, data)
}


/**
 * 更新会员
 * @param  data
 * @returns
 */
export const UpdateMember = async (data: any) => {
  return await CommonFetchPost(API.updateMember, data)
}

/**
 * 删除会员
 * @param  data
 * @returns
 */
export const DeleteMember = async (data: any) => {
  return await CommonFetchPost(API.deleteMember, data)
}


/**
 * 更新会员状态
 * @param  data
 * @returns
 */
export const UpdateMemberStatus = async (data: any) => {
  return await CommonFetchPost(API.updateMemberStatus, data)
}

/**
 * 更新会员状态
 * @param  data
 * @returns
 */
export const QueryMemberAllList = async () => {
  return await CommonFetchPost(API.queryMemberAllList)
}

/**
 * 查询代理设置列表
 * @param  data
 * @returns
 */
export const QueryMemberConfigList = async (data: any) => {
  return await CommonFetchPost(API.queryMemberConfigList, data)
}

/**
 * 创建代理设置列表
 * @param  data
 * @returns
 */
export const CreateMemberConfig = async (data: any) => {
  return await CommonFetchPost(API.createMemberConfig, data)
}

/**
 * 更新代理设置列表
 * @param  data
 * @returns
 */
export const UpdateMemberConfig = async (data: any) => {
  return await CommonFetchPost(API.updateMemberConfig, data)
}


/**
 * 删除代理设置列表
 * @param  data
 * @returns
 */
export const DeleteMemberConfig = async (data: any) => {
  return await CommonFetchPost(API.deleteMemberConfig, data)
}


/**
 * 代理设置状态更新
 * @param  data
 * @returns
 */
export const UpdateMemberConfigStatus = async (data: any) => {
  return await CommonFetchPost(API.updateMemberConfigStatus, data)
}

/**
 * 分红活动列表
 * @param  data
 * @returns
 */
export const QueryDistributionActivityList = async (data: any) => {
  return await CommonFetchPost(API.queryDistributionActivityList, data)
}

/**
 * 创建分红活动
 * @param  data
 * @returns
 */
export const CreteDistributionActivity = async (data: any) => {
  return await CommonFetchPost(API.creteDistributionActivity, data)
}

/**
 * 更新分红活动
 * @param  data
 * @returns
 */
export const UpdateDistributionActivity = async (data: any) => {
  return await CommonFetchPost(API.updateDistributionActivity, data)
}

/**
 * 更新分红活动状态
 * @param  data
 * @returns
 */
export const UpdateDistributionActivityStatus = async (data: any) => {
  return await CommonFetchPost(API.updateDistributionActivityStatus, data)
}

/**
 * 查询用户财富流水
 * @param  data
 * @returns
 */
export const QueryUserWealthRecordList = async (data: any) => {
  return await CommonFetchPost(API.queryUserWealthRecordList, data)
}

/** 积分明细 zy_user_points_record */
export const QueryUserPointsRecordList = async (data: any) => {
  return await CommonFetchPost(API.queryUserPointsRecordList, data)
}
/**
 * 用户积分记录导出
 * @param  data
 * @returns
 */
export const ExportUserWealthRecord = async (data: any, fileName= "用户积分记录导出.xlsx") => {
  return await CommonExportGet(API.exportUserWealthRecord, data,fileName)
}

/**
 * 查询分红池记录
 * @param  data
 * @returns
 */
export const QueryDistributionActivityRecordList = async (data: any) => {
  return await CommonFetchPost(API.queryDistributionActivityRecordList, data)
}

/**
 * 查询用户分红池记录
 * @param  data
 * @returns
 */
export const QueryDistributionActivityUserRecordList = async (data: any) => {
  return await CommonFetchPost(API.queryDistributionActivityUserRecordList, data)
}


/**
 * 查询提现订单记录
 * @param  data
 * @returns
 */
export const QueryWithdrawOrder = async (data: any) => {
  return await CommonFetchPost(API.queryWithdrawOrder, data)
}
/**
 * 查询提现订单记录ById
 * @param  data
 * @returns
 */
export const QueryWithdrawOrderById = async (data: any) => {
  return await CommonFetchPost(API.queryWithdrawOrderById, data)
}
/**
 * 提现单号变更
 * @param  data
 * @returns
 */
export const RefreshWithdrawOrder = async (data: any) => {
  return await CommonFetchPost(API.refreshWithdrawOrder, data)
}
/**
 * 提现订单导出
 * @param  data
 * @returns
 */
export const ExportWithdrawOrder = async (data: any, fileName= "提现订单导出.xlsx") => {
  return await CommonExportGet(API.exportWithdrawOrder, data,fileName)
}
/**
 * 查询店铺的提现订单记录
 * @param  data
 * @returns
 */
export const QueryShopWithdrawOrder = async (data: any) => {
  return await CommonFetchPost(API.queryShopWithdrawOrder, data)
}
/**
 * 申请提现
 * @param  data
 * @returns
 */
export const ApplyWithdraw = async (data: any) => {
  return await CommonFetchPost(API.applyWithdraw, data)
}
/**
 * 申请提现-初审通过
 * @param  data
 * @returns
 */
export const FirstApplyWithdrawPass = async (data: any) => {
  return await CommonFetchPost(API.firstApplyWithdrawPass, data)
}
/**
 * 申请提现-通过
 * @param  data
 * @returns
 */
export const ApplyWithdrawPass = async (data: any) => {
  return await CommonFetchPost(API.applyWithdrawPass, data)
}
/**
 * 申请提现-短信验证
 * @param  data
 * @returns
 */
export const WithdrawValidationSms = async (data: any) => {
  return await CommonFetchPost(API.withdrawValidationSms, data)
}
/**
 * 申请提现-拒绝
 * @param  data
 * @returns
 */
export const ApplyWithdrawReject = async (data: any) => {
  return await CommonFetchPost(API.applyWithdrawReject, data)
}
/**
 * 查询店铺余额
 * @param  data
 * @returns
 */
export const QueryShopBalance = async (data: any) => {
  return await CommonFetchPost(API.queryShopBalance, data)
}


/**
 * 更新用户身份
 * @param  data
 * @returns
 */
export const UpdateUserInfoRole = async (data: any) => {
  return await CommonFetchPost(API.updateUserInfoRole, data)
}

/**
 * 更新用户财富
 * @param  data
 * @returns
 */
export const UpdateUserInfoWealth = async (data: any) => {
  return await CommonFetchPost(API.updateUserInfoWealth, data)
}

/** 手动调整用户积分余额（系统充值/系统扣减，写积分明细） */
export const ManualAdjustUserFrozenPoints = async (data: any) => {
  return await CommonFetchPost(API.manualAdjustUserFrozenPoints, data)
}

/** 分配型绿豆充值-试算 */
export const MungBeanAllocatePreview = async (data: any) => {
  return await CommonFetchPost(API.mungBeanAllocatePreview, data)
}

/** 分配型绿豆充值-执行 */
export const MungBeanAllocateExecute = async (data: any) => {
  return await CommonFetchPost(API.mungBeanAllocateExecute, data)
}

/** 分配型绿豆充值-批次列表 */
export const MungBeanAllocateBatchList = async (data: any) => {
  return await CommonFetchPost(API.mungBeanAllocateBatchList, data)
}

/** 分配型绿豆充值-批次详情 */
export const MungBeanAllocateBatchDetail = async (data: any) => {
  return await CommonFetchPost(API.mungBeanAllocateBatchDetail, data)
}

/** 分配型绿豆充值-分配明细列表（含统计） */
export const MungBeanAllocateDetailList = async (data: any) => {
  return await CommonFetchPost(API.mungBeanAllocateDetailList, data)
}

/** 分配型绿豆充值-沉淀记录列表（含统计） */
export const MungBeanAllocateSedimentList = async (data: any) => {
  return await CommonFetchPost(API.mungBeanAllocateSedimentList, data)
}

export const SpecialPricePoolBalances = async (data: any = {}) => {
  return await CommonFetchPost(API.specialPricePoolBalances, data)
}

export const SpecialPricePoolRecordList = async (data: any) => {
  return await CommonFetchPost(API.specialPricePoolRecordList, data)
}

export const SpecialPricePoolAdjust = async (data: any) => {
  return await CommonFetchPost(API.specialPricePoolAdjust, data)
}

export const SpecialPriceOrderAllocateList = async (data: any) => {
  return await CommonFetchPost(API.specialPriceOrderAllocateList, data)
}

export const SpecialPriceOrderAllocateDetail = async (data: any) => {
  return await CommonFetchPost(API.specialPriceOrderAllocateDetail, data)
}

/** 冻结 C 端用户（禁止登录并清除 Redis/token） */
export const FreezeUser = async (data: { userId: number }) => {
  return await CommonFetchPost(API.freezeUser, data)
}

/** 解冻 C 端用户（恢复可登录，需客户端重新登录） */
export const UnfreezeUser = async (data: { userId: number }) => {
  return await CommonFetchPost(API.unfreezeUser, data)
}

/**
 * 修改用户推荐人
 * @param  data
 * @returns
 */
export const UpdateUserInviteInfo = async (data: any) => {
  return await CommonFetchPost(API.updateUserInviteInfo, data)
}

/**
 * 修改用户推荐人
 * @param  data
 * @returns
 */
export const CreateUserInfo = async (data: any) => {
  return await CommonFetchPost(API.createUserInfo, data)
}


/**
 * 店铺订单状态统计数据
 * @param  data
 * @returns
 */
export const SumOrderShopData = async () => {
  return await CommonFetchPost(API.sumOrderShopData)
}

/**
 * 店铺订单统计数据
 * @param  data
 * @returns
 */
export const SumShopOrderReport = async (data: any) => {
  return await CommonFetchPost(API.sumShopOrderReport,data)
}

/**
 * 店铺订单统计数据
 * @param  data
 * @returns
 */
export const QueryShopOrderReportList = async (data: any) => {
  return await CommonFetchPost(API.queryShopOrderReportList,data)
}

export const QueryShopAddressList = async (data: any) => {
  return await CommonFetchPost(API.queryShopAddressList, data)
}
export const RegisterShop = async (data: any) => {
  return await CommonFetchPost(API.registerShop, data)
}
export const QueryShopRegistMerchantListById = async (data: any) => {
  return await CommonFetchPost(API.queryShopRegistMerchantListById, data)
}
export const OpenMerchantSucccess = async (data: any) => {
  return await CommonFetchPost(API.openMerchantSucccess, data)
}
export const HuifuRegistMerchant = async (data: any) => {
  return await CommonFetchPost(API.huifuRegistMerchant, data)
}
export const QueryMccList = async (data: any) => {
  return await CommonFetchPost(API.queryMccList, data)
}
export const LlpayOpenMerchant = async (data: any) => {
  return await CommonFetchPost(API.llpayOpenMerchant, data)
}
export const GetApplyPasswordElement = async (data: any) => {
  return await CommonFetchPost(API.getApplyPasswordElement, data)
}
export const OpenacctActivateApply = async (data: any) => {
  return await CommonFetchPost(API.openacctActivateApply, data)
}
export const OpenacctActivateVerify = async (data: any) => {
  return await CommonFetchPost(API.openacctActivateVerify, data)
}
export const PapAgreeApply = async (data: any) => {
  return await CommonFetchPost(API.papAgreeApply, data)
}
export const OpenNoPwdWithdrawal = async (data: any) => {
  return await CommonFetchPost(API.openNoPwdWithdrawal, data)
}

// 店铺流水记录
export const QueryShopWealthRecordList = async (data: any) => {
  return await CommonFetchPost(API.queryShopWealthRecordList, data)
}
/**
 * 店铺流水导出
 * @param  data
 * @returns
 */
export const ExportShopWealthRecordList = async (data: any, fileName= "店铺流水导出.xlsx") => {
  return await CommonExportGet(API.exportShopWealthRecordList, data,fileName)
}


export const CreateShopAddress = async (data: any) => {
  return await CommonFetchPost(API.createShopAddress, data)
}

export const UpdateShopAddress = async (data: any) => {
  return await CommonFetchPost(API.updateShopAddress, data)
}

export const DeleteShopAddress = async (data: any) => {
  return await CommonFetchPost(API.deleteShopAddress, data)
}

export const SumPlatformDataReport = async (data: any) => {
  return await CommonFetchPost(API.sumPlatformDataReport, data)
}

export const SumPlatformTotalData = async () => {
  return await CommonFetchPost(API.sumPlatformTotalData)
}

export const QueryPartnerList = async (data: any) => {
  return await CommonFetchPost(API.queryPartnerList,data)
}

export const CreatePartner = async (data: any) => {
  return await CommonFetchPost(API.createPartner,data)
}

export const UpdatePartner = async (data: any) => {
  return await CommonFetchPost(API.updatePartner,data)
}

export const DeletePartner = async (data: any) => {
  return await CommonFetchPost(API.deletePartner,data)
}

export const QueryPartnerAllList = async () => {
  return await CommonFetchPost(API.queryPartnerAllList)
}

export const QueryAnnouncementList = async (data: any) => {
  return await CommonFetchPost(API.queryAnnouncementList,data)
}

export const CreateAnnouncement = async (data: any) => {
  return await CommonFetchPost(API.createAnnouncement,data)
}

export const UpdateAnnouncement = async (data: any) => {
  return await CommonFetchPost(API.updateAnnouncement,data)
}

export const DeleteAnnouncement = async (data: any) => {
  return await CommonFetchPost(API.deleteAnnouncement,data)
}

export const QueryInvoiceTypeList = async (data: any) => {
  return await CommonFetchPost(API.queryInvoiceTypeList,data)
}

export const QueryAllInvoiceTypeList = async () => {
  return await CommonFetchPost(API.queryAllInvoiceTypeList,{})
}

export const CreateInvoiceType = async (data: any) => {
  return await CommonFetchPost(API.createInvoiceType,data)
}

export const UpdateInvoiceType = async (data: any) => {
  return await CommonFetchPost(API.updateInvoiceType,data)
}

export const DeleteInvoiceType = async (data: any) => {
  return await CommonFetchPost(API.deleteInvoiceType,data)
}


export const QueryNewsList = async (data: any) => {
  return await CommonFetchPost(API.queryNewsList,data)
}

export const CreateNews = async (data: any) => {
  return await CommonFetchPost(API.createNews,data)
}

export const UpdateNews = async (data: any) => {
  return await CommonFetchPost(API.updateNews,data)
}

export const DeleteNews = async (data: any) => {
  return await CommonFetchPost(API.deleteNews,data)
}

export const QueryIndexHomeConfig = async (data: any = {}) => {
  return await CommonFetchPost(API.queryIndexHomeConfig, data)
}

export const UpdateIndexHomeConfig = async (data: any) => {
  return await CommonFetchPost(API.updateIndexHomeConfig, data)
}

export const QueryOriginStoryList = async (data: any) => {
  return await CommonFetchPost(API.queryOriginStoryList, data)
}

export const CreateOriginStory = async (data: any) => {
  return await CommonFetchPost(API.createOriginStory, data)
}

export const UpdateOriginStory = async (data: any) => {
  return await CommonFetchPost(API.updateOriginStory, data)
}

export const DeleteOriginStory = async (data: any) => {
  return await CommonFetchPost(API.deleteOriginStory, data)
}

export const QueryManageCommentList = async (data: any) => {
  return await CommonFetchPost(API.queryManageCommentList, data)
}

export const UpdateCommentDisplayStatus = async (data: any) => {
  return await CommonFetchPost(API.updateCommentDisplayStatus, data)
}

/**
 * 查询平台财富流水
 * @param  data
 * @returns
 */
export const QueryWealthRecordList = async (data: any) => {
  return await CommonFetchPost(API.queryWealthRecordList, data)
}

export const QueryWealthRecordSummary = async (data: any) => {
  return await CommonFetchPost(API.queryWealthRecordSummary, data)
}


/**
 * 平台PV流水导出
 * @param  data
 * @returns
 */
export const ExportWealthRecord = async (data: any, fileName= "平台PV流水.xlsx") => {
  return await CommonExportGet(API.exportWealthRecord, data,fileName)
}

/**
 * 查询店铺余额记录
 * @param  data
 * @returns
 */
export const QueryShopBalanceRecordList = async (data: any) => {
  return await CommonFetchPost(API.queryShopBalanceRecordList, data)
}
/**
 * 导出店铺余额记录
 * @param  data
 * @returns
 */
export const ExportShopBalanceRecord = async (data: any, fileName= "店铺余额记录.xlsx") => {
  console.log(data)
  return await CommonExportGet(API.exportShopBalanceRecord, data,fileName)
}
/**
 * 店铺余额支付，只在提现的时候用
 * @param  data
 * @returns
 */
export const ShopBalancePay = async (data: any) => {
  return await CommonFetchPost(API.shopBalancePay, data)
}

/**
 * 查询地区代理设置列表
 * @param  data
 * @returns
 */
export const QueryMemberAddressConfigList = async (data: any) => {
  return await CommonFetchPost(API.queryMemberAddressConfigList, data)
}

/**
 * 查询地区代理设置列表
 * @param  data
 * @returns
 */
export const CreateMemberAddressConfig = async (data: any) => {
  return await CommonFetchPost(API.createMemberAddressConfig, data)
}

/**
 * 查询地区代理设置列表
 * @param  data
 * @returns
 */
export const UpdateMemberAddressConfig = async (data: any) => {
  return await CommonFetchPost(API.updateMemberAddressConfig, data)
}

/**
 * 查询地区代理设置列表
 * @param  data
 * @returns
 */
export const DeleteMemberAddressConfig = async (data: any) => {
  return await CommonFetchPost(API.deleteMemberAddressConfig, data)
}

/**
 * 查询操作日志列表
 * @param  data
 * @returns
 */
export const QueryLogList = async (data: any) => {
  return await CommonFetchPost(API.queryLogList, data)
}

/**
 * 操作日志导出
 * @param  data
 * @returns
 */
export const ExportOperLog = async (data: any, fileName= "操作日志导出.xlsx") => {
  return await CommonExportGet(API.exportOperLog, data,fileName)
}

/**
 * 删除操作日志
 * @param  data
 * @returns
 */
export const DeleteOperLog = async (data: any) => {
  return await CommonFetchPost(API.deleteOperLog, data)
}

/**
 * 清空操作日志
 * @param  data
 * @returns
 */
export const ClearAllOperLog = async (data: any) => {
  return await CommonFetchPost(API.clearAllOperLog, data)
}

/**
 * 查询财富分析首页数据
 * @param  data
 * @returns
 */
export const QueryFinanceIndexData = async (data: any) => { return await CommonFetchPost(API.queryFinanceIndexData, data)}
/**
 * 查询全平台每日销售统计表
 * @param  data
 * @returns
 */
export const QueryDailySalesStatList = async (data: any) => { return await CommonFetchPost(API.queryDailySalesStatList, data)}
/**
 * 全平台每日销售统计表-导出
 * @param  data
 * @returns
 */
export const ExportDailySalesStat = async (data: any, fileName= "default.xlsx") => {
  return await CommonExportGet(API.exportDailySalesStat, data,fileName)
}
/**
 * 查询能量值&贡献值日统计表
 * @param  data
 * @returns
 */
export const QueryEnergyContributionStatList = async (data: any) => { return await CommonFetchPost(API.queryEnergyContributionStatList, data)}
/**
 * 查询能量值&贡献值日统计表-导出
 * @param  data
 * @returns
 */
export const ExportEnergyContributionStat = async (data: any, fileName= "default.xlsx") => {
  return await CommonExportGet(API.exportEnergyContributionStat, data,fileName)
}
/**
 * 查询绿豆每日全局统计汇总表
 * @param  data
 * @returns
 */
export const QueryMengBeanSummaryList = async (data: any) => { return await CommonFetchPost(API.queryMengBeanSummaryList, data)}
/**
 * 查询绿豆每日全局统计汇总表-导出
 * @param  data
 * @returns
 */
export const ExportMengBeanSummary = async (data: any, fileName= "default.xlsx") => {
  return await CommonExportGet(API.exportMengBeanSummary, data,fileName)
}
/**
 * 查询平台PV每日统计汇总表
 * @param  data
 * @returns
 */
export const QueryPlatformPvSummaryList = async (data: any) => { return await CommonFetchPost(API.queryPlatformPvSummaryList, data)}

export const ManualAdjustPlatformPv = async (data: any) => {
  return await CommonFetchPost(API.manualAdjustPlatformPv, data)
}

export const PreviewMixedPayRelease = async (data: any) => {
  return await CommonFetchPost(API.previewMixedPayRelease, data)
}

export const HandleMixedPayRelease = async (data: any) => {
  return await CommonFetchPost(API.handleMixedPayRelease, data)
}
/**
 * 查询平台PV每日统计汇总表-导出
 * @param  data
 * @returns
 */
export const ExportPlatformPvSummary = async (data: any, fileName= "default.xlsx") => {
  return await CommonExportGet(API.exportPlatformPvSummary, data,fileName)
}

/** 特殊关单退绿豆 */
export const ShopSpecialRefundPreview = async (data: any) => {
  return await CommonFetchPost(API.shopSpecialRefundPreview, data)
}
export const ShopSpecialRefundExecute = async (data: any, longTimeout = false) => {
  if (longTimeout) {
    return await CommonFetchPostLong(API.shopSpecialRefundExecute, data, 300000)
  }
  return await CommonFetchPost(API.shopSpecialRefundExecute, data)
}
export const ShopSpecialRefundPreviewExecuteItem = async (data: any) => {
  return await CommonFetchPost(API.shopSpecialRefundPreviewExecuteItem, data)
}
export const ShopSpecialRefundPreviewRollback = async (data: any) => {
  return await CommonFetchPost(API.shopSpecialRefundPreviewRollback, data)
}
export const ShopSpecialRefundRollback = async (data: any) => {
  return await CommonFetchPost(API.shopSpecialRefundRollback, data)
}
export const ShopSpecialRefundQueryBatch = async (data: any) => {
  return await CommonFetchPost(API.shopSpecialRefundQueryBatch, data)
}
export const ExportShopSpecialRefundPreviewExcel = async (data: any, fileName = '特殊关单预估.xlsx') => {
  return await CommonExportGet(API.exportShopSpecialRefundPreviewExcel, data, fileName)
}
export const ExportShopSpecialRefundResultExcel = async (data: any, fileName = '特殊关单执行结果.xlsx') => {
  return await CommonExportGet(API.exportShopSpecialRefundResultExcel, data, fileName)
}
export const ExportShopSpecialRefundRollbackExcel = async (data: any, fileName = '特殊关单回滚.xlsx') => {
  return await CommonExportGet(API.exportShopSpecialRefundRollbackExcel, data, fileName)
}
export const ShopSpecialRefundListBatch = async (data: any) => {
  return await CommonFetchPost(API.shopSpecialRefundListBatch, data)
}
export const ShopSpecialRefundQueryBatchItemDetail = async (data: any) => {
  return await CommonFetchPost(API.shopSpecialRefundQueryBatchItemDetail, data)
}
export const ShopSpecialRefundListUserLogByBatch = async (data: any) => {
  return await CommonFetchPost(API.shopSpecialRefundListUserLogByBatch, data)
}
export const ShopSpecialRefundListUserLogByUser = async (data: any) => {
  return await CommonFetchPost(API.shopSpecialRefundListUserLogByUser, data)
}
export const ShopSpecialRefundQueryLossAnalysis = async (data: any) => {
  return await CommonFetchPost(API.shopSpecialRefundQueryLossAnalysis, data)
}
export const ShopSpecialRefundQueryPlatformLossAnalysis = async () => {
  return await CommonFetchPostLong(API.shopSpecialRefundQueryPlatformLossAnalysis, {}, 300000)
}
export const ShopSpecialRefundListExecSuccess = async (data: any) => {
  return await CommonFetchPost(API.shopSpecialRefundListExecSuccess, data)
}
export const ShopSpecialRefundListOperateLog = async (data: any) => {
  return await CommonFetchPost(API.shopSpecialRefundListOperateLog, data)
}
export const ExportShopSpecialRefundExecSuccessExcel = async (data: any, fileName = '特殊关单执行成功明细.xlsx') => {
  return await CommonExportGet(API.exportShopSpecialRefundExecSuccessExcel, data, fileName)
}
/**
 * 查询提现统计&直营店铺连连余额日统计表
 * @param  data
 * @returns
 */
export const QueryWithdrawMerchantBalanceStatList = async (data: any) => { return await CommonFetchPost(API.queryWithdrawMerchantBalanceStatList, data)}
/**
 * 查询提现统计&直营店铺连连余额日统计表-导出
 * @param  data
 * @returns
 */
export const ExportWithdrawMerchantBalanceStat = async (data: any, fileName= "default.xlsx") => {
  return await CommonExportGet(API.exportWithdrawMerchantBalanceStat, data,fileName)
}
/**
 * 查询财务销售明细统计列表
 * @param  data
 * @returns
 */
export const QueryFinanceSalesStatList = async (data: any) => { return await CommonFetchPost(API.queryFinanceSalesStatList, data)}
/**
 * 财务销售明细统计-导出
 * @param  data
 * @returns
 */
export const ExportFinanceSalesStat = async (data: any, fileName= "default.xlsx") => {
  return await CommonExportGet(API.exportFinanceSalesStat, data,fileName)
}
/**
 * 查询财务绿豆明细统计列表
 * @param  data
 * @returns
 */
export const QueryFinanceMungBeanStatList = async (data: any) => { return await CommonFetchPost(API.queryFinanceMungBeanStatList, data)}
/**
 * 财务绿豆明细统计-导出
 * @param  data
 * @returns
 */
export const ExportFinanceMungBeanStat = async (data: any, fileName= "default.xlsx") => {
  return await CommonExportGet(API.exportFinanceMungBeanStat, data,fileName)
}

export const QueryFinanceBizReconcileIndexData = async (data: any) => {
  return await CommonFetchPost(API.queryFinanceBizReconcileIndexData, data)
}
export const QueryFinanceAllocateRechargeDailyStatList = async (data: any) => {
  return await CommonFetchPost(API.queryFinanceAllocateRechargeDailyStatList, data)
}
export const ExportFinanceAllocateRechargeDailyStat = async (data: any, fileName = 'default.xlsx') => {
  return await CommonExportGet(API.exportFinanceAllocateRechargeDailyStat, data, fileName)
}
export const QueryFinanceSpecialPriceDailyStatList = async (data: any) => {
  return await CommonFetchPost(API.queryFinanceSpecialPriceDailyStatList, data)
}
export const ExportFinanceSpecialPriceDailyStat = async (data: any, fileName = 'default.xlsx') => {
  return await CommonExportGet(API.exportFinanceSpecialPriceDailyStat, data, fileName)
}
export const QueryFinanceDistributionDailyStatList = async (data: any) => {
  return await CommonFetchPost(API.queryFinanceDistributionDailyStatList, data)
}
export const ExportFinanceDistributionDailyStat = async (data: any, fileName = 'default.xlsx') => {
  return await CommonExportGet(API.exportFinanceDistributionDailyStat, data, fileName)
}
export const QueryFinanceBizPvReconcileDailyStatList = async (data: any) => {
  return await CommonFetchPost(API.queryFinanceBizPvReconcileDailyStatList, data)
}
export const ExportFinanceBizPvReconcileDailyStat = async (data: any, fileName = 'default.xlsx') => {
  return await CommonExportGet(API.exportFinanceBizPvReconcileDailyStat, data, fileName)
}
export const RegenerateFinanceBizReconcileStat = async (data: any) => {
  return await CommonFetchPost(API.regenerateFinanceBizReconcileStat, data)
}

export const QueryFinanceWealthWayDailyIndexData = async (data: any) => {
  return await CommonFetchPost(API.queryFinanceWealthWayDailyIndexData, data)
}
export const QueryFinanceWealthWayDailyList = async (data: any) => {
  return await CommonFetchPost(API.queryFinanceWealthWayDailyList, data)
}
export const ExportFinanceWealthWayDaily = async (data: any, fileName = 'default.xlsx') => {
  return await CommonExportGet(API.exportFinanceWealthWayDaily, data, fileName)
}
export const QueryFinanceAssetDailyBalanceList = async (data: any) => {
  return await CommonFetchPost(API.queryFinanceAssetDailyBalanceList, data)
}
export const ExportFinanceAssetDailyBalance = async (data: any, fileName = 'default.xlsx') => {
  return await CommonExportGet(API.exportFinanceAssetDailyBalance, data, fileName)
}
export const RegenerateFinanceWealthWayDailyStat = async (data: any) => {
  return await CommonFetchPostLong(API.regenerateFinanceWealthWayDailyStat, data, 120000)
}
export const QueryFinanceWealthWayDailyCategoryGroup = async (data: any) => {
  return await CommonFetchPost(API.queryFinanceWealthWayDailyCategoryGroup, data)
}
export const QueryFinanceAsOfStat = async (data: any) => {
  return await CommonFetchPost(API.queryFinanceAsOfStat, data)
}

/**
 * 查询用户会员等级变更列表
 * @param  data
 * @returns
 */
export const QueryUserMemberChangeRecordList = async (data: any) => {
  return await CommonFetchPost(API.queryUserMemberChangeRecordList, data)
}
/**
 * 通过id查询
 * @param  data
 * @returns
 */
export const QueryUserMemberChangeRecordById = async (data: any) => {
  return await CommonFetchPost(API.queryUserMemberChangeRecordById, data)
}